"use strict";

class BladesCtrl {

    constructor($rootScope, $scope, bladesManager, $transitions) {
        this.blades = bladesManager.all();
        this.isLoading = {};

        $scope.$on('$viewContentLoaded', (event, viewConfig) => {
            if (viewConfig) {
                let viewName = viewConfig.viewDecl.$name;
                this.isLoading[viewName] = false;
            }
        });

        // (event, to, toParams, from, fromParams)

        $transitions.onSuccess({ }, (transition) => {

            let from = transition.from();
            let to = transition.to();
            let fromParams = transition.params('from');
            let toParams = transition.params('to');

            for (var key in to.views) {
                this.isLoading[key] = true;
            }

            //this.isLoading = true;
            bladesManager.setPreviousState(from);
            bladesManager.setStateParams(fromParams, toParams);

            $rootScope.previousState = from;
        });
    }
}

BladesCtrl.$inject = ['$rootScope', '$scope', 'bladesManager', '$transitions'];

module.exports = BladesCtrl;
